
import React from 'react'
import ReactDOM, {findDOMNode} from 'react-dom';
import CSSPropertyOperations from 'react/lib/CSSPropertyOperations';
import shallowCompare from 'react/lib/shallowCompare';

const types = React.PropTypes

export default class JSXModal extends React.Component {
    constructor(props) {
        super(props)
        this.width = `${this.props.size.width || this.props.size || 50}vw`
        this.height = `${this.props.size.height || this.props.size || 50}vh`
        this.translate = `translate( calc(50vw - (${this.width} / 2)), calc(50vh - (${this.height} / 2)))`
    }

    cancel() {
    }

    render() {
        const title = this.props.title
        const message = this.props.message
        const danger = this.props.danger
        const okText = this.props.okText
        return (
            <Portal closeOnEsc isOpened={this.props.isOpened()}>
                <div class="ps-modal" style={{width: `${this.width}`, height: `${this.height}`, transform: `${this.translate}`}}>
                    <style>{`
                        .ps-modal {
                            display: flex;
                            position: absolute;
                            z-index: 1000;
                            top: 0;
                        }
                        .modal-content {
                        }
                        .modal-contents {
                            margin: auto;
                            width: 100%;
                            height: 100%;
                        }
                        .ps-modal-modal {
                            display: block;
                            position: relative;
                            overflow: visible;
                        }
                        .modal-footer{
                            position: absolute;
                            bottom: 0;
                        }
                        .modal-body {
                            height: calc(100% - 65px);
                        }
                        .modal-footer {
                            width: 100%;
                            padding: 15px;
                        }
                        .modal-footer .btn{
                            margin: unset
                        }
                        .modal-close {
                            float: right;
                        }
                    `}</style>
                    <div class="modal-contents">
                        <div class="ps-modal-modal modal" tabIndex="-1" role="dialog">
                            <div>
                                <div class="modal-content" style={{width: '100%', height: `${this.height}`}}>
                                    <div class={"modal-header " + (danger ? "alert-danger" : "alert-success")}>
                                        <button type="button" onClick={this.props.cancel} class="close" data-dismiss="modal" aria-label="Ok">
                                            <span aria-hidden="true">
                                                &times;
                                            </span>
                                        </button>
                                        <h4 class="modal-title" id="gridSystemModalLabel">
                                            {title}
                                        </h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <p>{message}</p>
                                                <div class="timeline-table-multi">{this.props.children}</div>
                                            </div>
                                        </div>
                                        <div class="modal-footer row">
                                            {okText && (
                                                <button type="button" onClick={this.props.okAction} class="btn btn-info btn-secondary btn-fill move-on pull-left" data-dismiss="modal">
                                                    {okText}
                                                </button>
                                            )}
                                            <button type="button" onClick={this.props.cancel} class={"btn modal-close btn-info " + (danger ? "btn-danger" : "success") + " btn-fill"} data-dismiss="modal">
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>
        )
    }
}

JSXModal.propTypes = {
    title: types.string.isRequired,
    message: types.string.isRequired,
    danger: types.bool,
    okText: types.string,
    size: types.oneOfType([
        types.shape({
            height: types.string.isRequired,
            width: types.string.isRequired
        }),
        types.string.isRequired
    ]),
    closeOnEsc: types.bool,
    closeOnOutsideClick: types.bool,
    isOpened: types.func.isRequired,
    cancel: types.func.isRequired,
    okAction: types.func,
    portalProps: types.shape({
        className: types.string,
        style: types.object,
        onOpen: types.func,
        onClose: types.func,
        beforeClose: types.func,
        onUpdate: types.func
    })
}

const KEYCODES = {
  ESCAPE: 27
};

/*
This class adds the Portal functionality from tajo/react-portal at the relevant react@0.14.7
commit (8e4ecc51d458d415faa84136a14a482d019005b4). Deprecated in react@16 this functionality was
added to react-dom via ReactDOM.Portal. Find the repo this class was pulled from here:
    https://github.com/tajo/react-portal/tree/8e4ecc51d458d415faa84136a14a482d019005b4
*/
class Portal extends React.Component {

  constructor() {
    super();
    this.state = {active: false};
    this.handleWrapperClick = this.handleWrapperClick.bind(this);
    this.closePortal = this.closePortal.bind(this);
    this.handleOutsideMouseClick = this.handleOutsideMouseClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.portal = null;
    this.node = null;
  }

  componentDidMount() {
    if (this.props.closeOnEsc) {
      document.addEventListener('keydown', this.handleKeydown);
    }

    if (this.props.closeOnOutsideClick) {
      document.addEventListener('mousedown', this.handleOutsideMouseClick);
      document.addEventListener('touchstart', this.handleOutsideMouseClick);
    }

    if (this.props.isOpened) {
      this.openPortal();
    }
  }

  componentWillReceiveProps(newProps) {
    // portal's 'is open' state is handled through the prop isOpened
    if (typeof newProps.isOpened !== 'undefined') {
      if (newProps.isOpened) {
        if (this.state.active) {
          this.renderPortal(newProps);
        } else {
          this.openPortal(newProps);
        }
      }
      if (!newProps.isOpened && this.state.active) {
        this.closePortal();
      }
    }

    // portal handles its own 'is open' state
    if (typeof newProps.isOpened === 'undefined' && this.state.active) {
      this.renderPortal(newProps);
    }
  }

  componentWillUnmount() {
    if (this.props.closeOnEsc) {
      document.removeEventListener('keydown', this.handleKeydown);
    }

    if (this.props.closeOnOutsideClick) {
      document.removeEventListener('mousedown', this.handleOutsideMouseClick);
      document.removeEventListener('touchstart', this.handleOutsideMouseClick);
    }

    this.closePortal(true);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  renderPortal(props) {
    if (!this.node) {
      this.node = document.createElement('div');
      if (props.className) {
        this.node.className = props.className;
      }
      if (props.style) {
        CSSPropertyOperations.setValueForStyles(this.node, props.style);
      }
      document.body.appendChild(this.node);
    }
    this.portal = ReactDOM.unstable_renderSubtreeIntoContainer(this, React.cloneElement(props.children, {closePortal: this.closePortal}), this.node, this.props.onUpdate);
  }

  render() {
    if (this.props.openByClickOn) {
      return React.cloneElement(this.props.openByClickOn, {onClick: this.handleWrapperClick});
    } else {
      return null;
    }
  }

  handleWrapperClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.openPortal();
  }

  openPortal(props = this.props) {
    this.setState({active: true});
    this.renderPortal(props);

    this.props.onOpen(this.node);
  }

  closePortal(isUnmounted = false) {
    const resetPortalState = () => {
      if (this.node) {
        ReactDOM.unmountComponentAtNode(this.node);
        document.body.removeChild(this.node);
      }
      this.portal = null;
      this.node = null;
      if (!isUnmounted) {
        this.setState({active: false});
      }
    };

    if (this.state.active) {
      if (this.props.beforeClose) {
        this.props.beforeClose(this.node, resetPortalState);
      } else {
        resetPortalState();
      }

      this.props.onClose();
    }
  }

  handleOutsideMouseClick(e) {
    if (!this.state.active) { return; }

    const root = findDOMNode(this.portal);
    if (root.contains(e.target) || e.button !== 0) { return; }

    e.stopPropagation();
    this.closePortal();
  }

  handleKeydown(e) {
    if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
      this.closePortal();
    }
  }

}

Portal.propTypes = {
  className: React.PropTypes.string,
  style: React.PropTypes.object,
  children: React.PropTypes.element.isRequired,
  openByClickOn: React.PropTypes.element,
  closeOnEsc: React.PropTypes.bool,
  closeOnOutsideClick: React.PropTypes.bool,
  isOpened: React.PropTypes.bool,
  onOpen: React.PropTypes.func,
  onClose: React.PropTypes.func,
  beforeClose: React.PropTypes.func,
  onUpdate: React.PropTypes.func
};

Portal.defaultProps = {
  onOpen: () => {},
  onClose: () => {},
  onUpdate: () => {}
};


// WEBPACK FOOTER //
// app/components/UpcomingTasks/Modal.jsx